<template>
    <button
        :id="`cart-item-${cartItem.id}-delete-button`"
        @click="deleteCartItem(cartItem, shippingTimeId)"
        type="button"
        class="flex items-center text-xs font-medium text-nutreance-green hover:text-nutreance-green-lighter focus:outline-none"
    >
        <span class="sr-only">Delete</span>
        <LoadingIcon v-if="loading" class="h-4 w-4 mr-1" />
        <TrashIcon v-else class="h-4 w-4 mr-1" aria-hidden="true" />Delete
    </button>
</template>

<script setup lang="ts">
import { TrashIcon } from "@heroicons/vue/solid";
import { useCartItem } from "../../functions/useCartItem";
import LoadingIcon from "../LoadingIcon.vue";

defineProps<{
    cartItem?: any;
    shippingTimeId?: number;
}>();

const { loading, deleteCartItem } = useCartItem();
</script>
